"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { HiSearch, HiHome } from "react-icons/hi";
import { useLanguage } from "@/lib/i18n";
import ErrorLayout from "@/components/layout/ErrorLayout";
import { useParams } from "next/navigation";

export default function NotFound() {
  const params = useParams();
  // Fallback to 'id' if params.lang is missing or invalid, ensuring we respect the URL segment
  const currentLang = (params?.lang as string) === "en" ? "en" : "id";

  const content = currentLang === "id" ? {
    tagline: "Error 404",
    title: "Halaman Tidak Ditemukan",
    description: "Maaf, halaman yang Anda cari mungkin telah dihapus, dipindahkan, atau tidak tersedia saat ini.",
    backHome: "Kembali ke Beranda",
  } : {
    tagline: "Error 404",
    title: "Page Not Found",
    description: "Sorry, the page you are looking for may have been removed, moved, or is currently unavailable.",
    backHome: "Back to Home",
  };

  return (
    <ErrorLayout
      icon={HiSearch}
      tagline={content.tagline}
      title={content.title}
      description={content.description}
      actions={
        <Link href="/">
          <Button className="w-full md:w-auto bg-white text-brand-charcoal hover:bg-brand-gold hover:text-white px-8 py-6 rounded-none uppercase text-xs font-bold tracking-[0.2em] transition-all">
            <HiHome size={16} className="mr-2" /> {content.backHome}
          </Button>
        </Link>
      }
    />
  );
}
